import React from 'react';
import { FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const SaveForRetirementStepBody = () => {
  return (
    <FDStack direction={'column'} spacing={2} width={'100%'} maxWidth={425} paddingY={2} alignItems={'center'}>
      <FDStack direction="row" spacing={2} alignItems={'center'} justifyContent={'center'} width={'100%'}>
        <MetaControlField attr={'primaryRetirementAge'} />
        <MetaControlField attr={'primaryIsRetired'} />
      </FDStack>
      <FDStack direction="row" spacing={2} alignItems={'center'} justifyContent={'center'} width={'100%'}>
        <MetaControlField attr={'spouseRetirementAge'} />
        <MetaControlField attr={'spouseIsRetired'} />
      </FDStack>
    </FDStack>
  );
};

SaveForRetirementStepBody.propTypes = {};

export { SaveForRetirementStepBody };
